export default "__VITE_ASSET__DajpCtdq__"